exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".current-subscription .select-dialog-body,.current-subscription .select-options{max-height:250px}.current-subscription .btn.btn-danger{background-color:#ff5252;border-color:#ff5252}.current-subscription .top-margin{margin-top:30px!important}.current-subscription .ml-2{margin-left:0!important}.current-subscription .radio-buttons{padding-top:4px}.current-subscription textarea{width:100%;height:7rem;color:#545454;padding:9px}.current-subscription .renew-plan{background-color:#38c172;border-color:#38c172}", ""]);

// exports
